import React from 'react';
import {createUseStyles} from 'react-jss';

const useStyles = createUseStyles({
  errorBlock: {
    textAlign: 'center',
    padding: 10
  }
});

export const ErrorMessage = () => {
  const classes = useStyles();

  return <div className={classes.errorBlock}>Нет данных</div>;
};
